const ALLOWED_DOCUMENT_EXTENSIONS = ['.docx', '.doc', '.pdf', '.txt', '.rtf', '.odt', '.jpg', '.jpeg', '.png'];
const ALLOWED_DOCUMENT_ACCEPT = ALLOWED_DOCUMENT_EXTENSIONS.join(',');
const ALLOWED_DOCUMENT_TYPES_INFO = `Accepted file types: ${ALLOWED_DOCUMENT_EXTENSIONS.join(', ')}`;

const getFileExtension = (filename: string) =>
	filename.includes('.') ? filename.slice(filename.lastIndexOf('.')).toLowerCase() : '';

const isAllowedDocumentType = (filename: string) =>
	ALLOWED_DOCUMENT_EXTENSIONS.includes(getFileExtension(filename));

const showInvalidDocumentTypeError = (filename: string) => {
	const extension = getFileExtension(filename) || 'No extension';
	$('#invalidFileTypeMessage').text(`"${extension}" is not an accepted file type.\n\n${ALLOWED_DOCUMENT_TYPES_INFO}`);
	$('#invalidFileTypeModal').modal('show');
};

const isValidDocumentUpload = (element: HTMLInputElement, file: File) => {
	if (isAllowedDocumentType(file.name)) return true;

	element.value = '';
	showInvalidDocumentTypeError(file.name);
	return false;
};

export {
	ALLOWED_DOCUMENT_ACCEPT,
	ALLOWED_DOCUMENT_TYPES_INFO,
	isValidDocumentUpload
}
